"use client";
import React from "react";
import { Box } from "@mui/material";
import {
  Button,
  Input,
  Dropdown,
  Textarea,
  Label
} from "@int-traderjoes/ui-components-library";
import { useTheme } from "@/context";
import FormHeader from "@/utils/FormHeader";
import Constants from "@/static/constants/constants.json";

function VettingIngredientForm() {
  const { darkMode } = useTheme();
  return (
    <>
      <Box className="bg-white dark:bg-TJ-Dark2 border-TJ-Box-Border dark:border-TJ-Dark border">
        <Box className="w-full h-10 bg-TJ-Box-Light-Grey dark:bg-TJ-Dark3 flex items-center border-b border-b-TJ-Box-Border">
          <FormHeader title="Vetting Ingredients" />
        </Box>

        <form className="p-[1.5rem]">
          <Box className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-[1.5rem]">

            {/*  Vendor Name */}
            <Box>
              <Label
                className={darkMode ? "dark" : "light"}
                text="Vendor Name"
                htmlFor="vendorName"
              />
              <Input
                className={darkMode ? "dark" : "light"}
                name="vendorName"
                value=""
                maxLength={Constants.VENDOR_CORPORATE_OR_VENDOR_NAME_MAX_LENGTH}
              />
            </Box>

            {/* Ingredient list */}
            <Box>
              <Label
                className={darkMode ? "dark" : "light"}
                text="Ingredient list"
                htmlFor="ingredientList"
              />
              <Input
                name="ingredientList"
                value=""
                className={darkMode ? "dark" : "light"}
              />
            </Box>

            {/* Bioengineered Food Ingredient Disclosure */}
            <Box>
              <Label
                className={darkMode ? "dark" : "light"}
                text="Bioengineered Food Ingredient Disclosure"
              />
              <Dropdown
                className={darkMode ? "dark" : "light"}
                options={[
                  { label: "Yes", value: "1" },
                  { label: "No", value: "2" },
                  // { label: "Option 3", value: "3" },
                ]}
                name="bioengineeredFoodIngredientDisclosure"
                selectedValue="1" // Required for single selection mode
                selectedValues={["1"]} // Pass selected value as an array
                onChange={() => console.log("Selected Status:")}
              />
            </Box>

            {/* Bioengineered Ingredients */}
            <Box>
              <Label
                className={darkMode ? "dark" : "light"}
                text="Bioengineered Ingredients"
              />
              <Dropdown
                className={darkMode ? "dark" : "light"}
                options={[
                  { label: "Option 1", value: "1" },
                  { label: "Option 2", value: "2" },
                  { label: "Option 3", value: "3" },
                ]}
                name="bioengineeredFoodIngredientDisclosure"
                selectedValue="1" // Required for single selection mode
                selectedValues={["1"]} // Pass selected value as an array
                onChange={() => console.log("Selected Status:")}
              />
            </Box>

            {/* Highly Refined Ingredients */}
            <Box>
              <Label
                text="Highly Refined Ingredients"
                className={darkMode ? "dark" : "light"}
              />

              <Dropdown
                className={darkMode ? "dark" : "light"}
                options={[
                  { label: "Grocery A", value: "A" },
                  { label: "Grocery B", value: "B" },
                  { label: "Grocery C", value: "C" },
                ]}
                name="HighlyRefinedIngredients"
                selectedValue="A" // Required for single selection mode
                selectedValues={["A"]} // Pass selected value as an array
                onChange={() => console.log("Selected Status:")}
              />
            </Box>

            {/* Unacceptable Ingredients */}
            <Box>
              <Label
                className={darkMode ? "dark" : "light"}
                text="Unacceptable Ingredients"
              />
              <Dropdown
                className={darkMode ? "dark" : "light"}
                options={[
                  { label: "Option 1", value: "1" },
                  { label: "Option 2", value: "2" },
                  { label: "Option 3", value: "3" },
                ]}
                name="unacceptableIngredients"
                selectedValue="1" // Required for single selection mode
                selectedValues={["1"]} // Pass selected value as an array
                onChange={() => console.log("Selected Status:")}
              />
            </Box>

            {/* Suspect Ingredients */}
            <Box>
              <Label
                className={darkMode ? "dark" : "light"}
                text="Suspect Ingredients"
              />
              <Dropdown
                className={darkMode ? "dark" : "light"}
                options={[
                  { label: "Option 1", value: "1" },
                  { label: "Option 2", value: "2" },
                  { label: "Option 3", value: "3" },
                ]}
                name="SuspectIngredients"
                selectedValue="Day" // Required for single selection mode
                selectedValues={["Week"]} // Pass selected value as an array
                onChange={() => console.log("Selected Status:")}
              />
            </Box>

            {/* Acceptable Ingredients */}
            <Box>
              <Label
                className={darkMode ? "dark" : "light"}
                text="Acceptable Ingredients"
              />
              <Dropdown
                className={darkMode ? "dark" : "light"}
                options={[
                  { label: "Option 1", value: "1" },
                  { label: "Option 2", value: "2" },
                  { label: "Option 3", value: "3" },
                ]}
                name="acceptableIngredients"
                selectedValue="1" // Required for single selection mode
                selectedValues={["1"]} // Pass selected value as an array
                onChange={() => console.log("Selected Status:")}
              />
            </Box>

            {/* Red Flags Identified */}
            <Box>
              <Label
                className={darkMode ? "dark" : "light"}
                text="Red Flags Identified"
              />
              <Input
                className={darkMode ? "dark" : "light"}
                name="redFlagsIdentified"
                value=""
              />
            </Box>

            {/* Notification sent to Vendor */}
            <Box>
              <Label
                className={darkMode ? "dark" : "light"}
                text="Notification Sent to Vendor"
              />
              <Dropdown
                className={darkMode ? "dark" : "light"}
                options={[
                  { label: "Yes", value: "1" },
                  { label: "No", value: "2" },
                ]}
                name="notificationSentToVendor"
                selectedValue="1" // Required for single selection mode
                selectedValues={["1"]} // Pass selected value as an array
                onChange={() => console.log("Selected Status:")}
              />
            </Box>

            {/* Notification  */}
            <Box>
              <Label
                className={darkMode ? "dark" : "light"}
                text="Notification Sent to TJ Business User"
              />
              <Dropdown
                className={darkMode ? "dark" : "light"}
                options={[
                  { label: "Yes", value: "1" },
                  { label: "No", value: "2" },
                ]}
                name="notificationSentToTJBusinessUser"
                selectedValue="1" // Required for single selection mode
                selectedValues={["1"]} // Pass selected value as an array
                onChange={() => console.log("Selected Status:")}
              />
            </Box>

            {/* Discrepancies List */}
            <Box>
              <Label
                className={darkMode ? "dark" : "light"}
                text="Discrepancies List"
              />
              <Input
                className={darkMode ? "dark" : "light"}
                name="ingredientNotFoundList"
                value=""
                // filled
              />
            </Box>

            {/* Compliance Status */}
            <Box>
              <Label
                className={darkMode ? "dark" : "light"}
                text="Compliance Status"
              />
              <Input
                className={darkMode ? "dark" : "light"}
                name="complianceStatus"
                value=""
              />
            </Box>
            
            {/* Comments */}
            <Box className="sm:col-span-2">
              <Label className={darkMode ? "dark" : "light"} text="Comments" htmlFor="Comments" />
              <Textarea
                className={darkMode ? "dark" : "light"}
                value=""
                onChange={() => console.log("something")}
              />
            </Box>

          </Box>
        </form>
      </Box>

      {/* Save as Draft and Go to next buttons */}
      <Box className="mt-8 flex flex-col gap-[1.5rem] md:justify-end md:flex-row">
        <Button
          disabled
          size={"large"}
          text="save as draft"
          onClick={() => console.log("Clicked")}
        />
        <Button
          disabled
          size={"large"}
          text={"go to next"}
          onClick={() => console.log("Clicked")}
          primary
        />
      </Box>

    </>
  );
}

export default VettingIngredientForm;
